class StockNotifier {

    productId = null;
    variantId = null;

    elements = {};

    constructor(wrapper) {
        this.getElements(wrapper);
        this.setInitialState();
        this.setEvents();
    }

    getElements(wrapper) {
        this.elements.wrapper = wrapper;
        this.elements.form = wrapper.closest('form');
        this.elements.messages = wrapper.find('.stock-notifier__messages');
        this.elements.emailInput = wrapper.find('.stock-notifier__input--email');
    }

    setInitialState() {
        let productId = this.elements.wrapper.data('product');
        let variantId = this.elements.wrapper.data('initial-variant');

        if(productId && variantId) {
            this.enable(productId, variantId);
            return;
        }

        this.disable();
    }

    enable(productId, variantId) {
        this.productId = productId;
        this.variantId = variantId;
        this.elements.emailInput.prop('required', true);
        this.elements.wrapper.prop('hidden', false);
    }

    disable() {
        this.productId = null;
        this.variantId = null;
        this.clearMessages();
        this.elements.emailInput.val('');
        this.elements.emailInput.prop('required', false);
        this.elements.wrapper.prop('hidden', true);
    }

    async submit() {
        this.elements.wrapper.addClass('stock-notifier__wrapper--submitting');
        this.clearMessages();

        let response = await BIS.create(this.getEmail(), this.variantId, this.productId);

        if(response.status == 'OK' && typeof response.message != 'undefined') {
            this.showSuccessMessage(response.message);
        }

        if(response.status == 'Error' && typeof response.errors != 'undefined' && typeof response.errors.base != 'undefined' ) {
            for(let i=0; i<response.errors.base.length; i++) {
                this.showErrorMessage(response.errors.base[i]);
            }
        }

        this.elements.wrapper.removeClass('stock-notifier__wrapper--submitting');
    }

    clearMessages() {
        this.elements.messages.empty();
    }

    showSuccessMessage(message) {
        this.elements.messages.append('<p class="stock-notifier__message stock-notifier__message--success">' + message + '</p>');
    }

    showErrorMessage(message) {
        this.elements.messages.append('<p class="stock-notifier__message stock-notifier__message--error">' + message + '</p>');
    }

    getEmail() {
        let formData = new FormData(this.elements.form.get(0));

        return formData.get('stock_notifier_email');
    }

    setEvents() {
        if(typeof BoosterTheme.swatches != 'undefined') {
            BoosterTheme.swatches.events.on(
                'booster:swatch:update',
                (args) => {
                    if(!args.selectedVariant) {
                        this.disable();

                        return;
                    }

                    if(args.selectedVariant.available) {
                        this.disable();

                        return;
                    }

                    this.enable(parseInt(args.product.id), parseInt(args.selectedVariant.id));
                }
            );
        }

        this.elements.form.on(
            'submit',
            (event) => {
                if(!this.productId || !this.variantId) {
                    return;
                }

                event.preventDefault();
                this.submit();
            }
        );
    }

}

var stockNotifiers = [];

function constructStockNotifiers() {
    if(typeof BoosterTheme == 'undefined') {
        setTimeout(constructStockNotifiers, 500);

        return;
    }

    if(typeof BIS == 'undefined') {
        setTimeout(constructStockNotifiers, 500);

        return;
    }

    jQuery('.stock-notifier__wrapper').each(
        function() {
            stockNotifiers.push(new StockNotifier(jQuery(this)));
        }
    );
};

jQuery(document).ready(
    function() {
        constructStockNotifiers();
    }
);
